import { render, staticRenderFns } from "./BaseSearch.vue?vue&type=template&id=55b81bec&"
import script from "./BaseSearch.vue?vue&type=script&lang=js&"
export * from "./BaseSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports